module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\n<fieldset class="gererpiecesjointes-detail">\n  <div class="phx-formTable">\n    <div class="phx-formErrors ui-state-error"></div>\n    <div>\n      <div class="gererpiecesjointes-content">\n        <div class="gererpiecesjointes-form-inputs">\n          <span class="ctxGestionCollab"></span><br>\n          <br>\n          <span class="ctxDescription"></span>\n        </div>\n      </div>\n    </div>\n  </div>\n</fieldset>\n<span class="table_pieces_jointes"></span>\n<span class="file_transfer"></span>';
}
return __p;
};
